import { useOfficeScopedPermissionCan } from "@Front/Hooks/useOfficeScopedPermissionCan";
import type { MenuRulePermissionCanFn } from "@Front/Utils/filterMenuItemsByCan";

/**
 * `can` matrice dédié au menu **« Espace office »** (header `OfficeMenu` + burger `OfficeMenuSection`) :
 * même identité bureau que le sélecteur ({@link resolveNotaryMenuOfficeIdentity}), scope `menuOfficeUid`, et lecture
 * tranche `notary` lorsque le store / JWT est en contexte invité — le menu ne suit pas le dossier ouvert.
 *
 * **Audit des autres `Menu` + `useMatrixFilteredMenuItems` (2026-04)** : seuls ces deux points filtrent des items avec
 * `rules` matrice au niveau navigation bureau. Les autres usages de `Menu` (dossier, super-admin, design system) restent
 * sur le `can` du store : permissions alignées sur le **contexte JWT / dossier courant**, sans override sélecteur.
 */
export function useOfficeMenuMatrixCan(): MenuRulePermissionCanFn {
	return useOfficeScopedPermissionCan();
}
